export const sortBy = <T>(sortValueFn: (item: T) => any) => {
  return (a: T, b: T): number => {
    const aValue = sortValueFn(a);
    const bValue = sortValueFn(b);
    if (aValue < bValue) return -1;
    else if (aValue > bValue) return 1;
    else return 0;
  };
};

export const sortByAdditional = <T>(
  sortValueFn: (item: T) => any,
  sortFn: (a: T, b: T) => number
) => {
  return (a: T, b: T): number => {
    const result = sortFn(a, b);
    if (result !== 0) return result;
    return sortBy(sortValueFn)(a, b);
  };
};

export const reversed = <T>(sortValueFn: (a: T, b: T) => any) => {
  return (a: T, b: T): number => {
    return sortValueFn(b, a);
  };
};

// Best-effort relative-time formatter for "last fetched" / "last run" labels.
// Falls back to a date string when the timestamp is older than a month, and to
// the raw input when it isn't a parseable date.
export const formatRelativeTime = (iso: string): string => {
  const then = new Date(iso).getTime();
  if (isNaN(then)) return iso;
  const seconds = Math.floor((Date.now() - then) / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
};
